import { Text, Box, Icon, HStack, Label, VStack } from '@medely/ui-kit';
import React from 'react';
import { JobDetailsListItem } from '../jobs/JobDetailsListItem';
import { PostBookingInfoProps } from './interface';
import { jobDate, jobTime } from './postBookingUtils';
import useDialog from '@mp/hooks/useDialog';
import { CalendlyModal } from '../calendlyModal/CalendlyModal';
import { useProfessionalTodos } from '@mp/hooks';
import { JobDetailsFragment } from '../jobs/jobDetailsComponents/graphql';
import { parseFragmentData } from '@mp/graphql/generated';

export const PostBookingInfo = ({ job: inputJob, smallIcon = false }: PostBookingInfoProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);
  const { open, openDialog, closeDialog } = useDialog();
  const { todos } = useProfessionalTodos();

  const needsRescreening = todos?.rescreening || false;

  return (
    <Box px={1}>
      <Text size="l" color="text.primary">
        Congratulations you are now scheduled for a shift at {job?.location?.name}.
      </Text>
      <Box py={2}>
        <Box py={2}>
          <JobDetailsListItem
            icon={
              <Icon
                name="light-location-dot"
                iconSize={smallIcon ? '12px' : '18px'}
                color="text.primary"
                variant="custom"
              />
            }
          >
            <Text size="m">{`${job?.location?.address_city}, ${job?.location?.state?.abbreviation} ${job?.location?.address_zip}`}</Text>
          </JobDetailsListItem>
        </Box>
        <Box py={2}>
          <JobDetailsListItem
            icon={
              <Icon
                name="light-calendar"
                iconSize={smallIcon ? '12px' : '18px'}
                color="text.primary"
                variant="custom"
              />
            }
          >
            <Text size="m">{jobDate(job?.starts_date, job?.location?.timezone_lookup)}</Text>
            <Text size="m">
              {jobTime({
                approvedClockIn: job?.approved_clock_in,
                approvedClockOut: job?.approved_clock_out,
                currentStartsTime: job?.starts_time,
                currentEndsTime: job?.ends_time,
                timezoneLookup: job?.location?.timezone_lookup,
                guaranteedMinimumHours: job?.guaranteed_minimum_hours,
                status: job?.status,
              })}
            </Text>
          </JobDetailsListItem>
        </Box>
      </Box>
      {needsRescreening && (
        <Box bgColor="state.error.backing-1" borderRadius="5px" p={2}>
          <HStack justifyContent="space-between">
            <VStack gap={0.5}>
              <Label size="m" color="state.error.primary">
                Screening out of date
              </Label>
              <Text size="m" color="state.error.primary">
                Please schedule a follow-up call.
              </Text>
            </VStack>
            <Box onClick={openDialog}>
              <Box
                borderWidth={1}
                borderColor="state.error.secondary"
                py={0.5}
                px={1}
                borderRadius="50px"
              >
                <Label size="m" color="state.error.primary">
                  Schedule
                </Label>
              </Box>
            </Box>
          </HStack>
        </Box>
      )}

      <CalendlyModal open={open} onClose={closeDialog} />
    </Box>
  );
};
